import Vue from 'vue';
import Router from 'vue-router';
import AuthenticationService from '@/services/AuthenticationService';

// Route Dependencies
import Login from '@/components/pages/Login/Login.vue';
import Dashboard from '@/components/pages/Dashboard/Dashboard.vue';
import Retailers from '@/components/pages/Retailers/Retailers.vue';
import RetailersDetail from '@/components/pages/RetailersDetail/RetailersDetail.vue';
import RetailersMulti from '@/components/pages/RetailersMulti/RetailersMulti.vue';
import ServiceProviders from '@/components/pages/ServiceProviders/ServiceProviders.vue';
import ServiceProviderDetail from '@/components/pages/ServiceProviderDetail/ServiceProviderDetail.vue';
import ServiceRelationships from '@/components/pages/ServiceRelationships/ServiceRelationships.vue';
import Washrooms from '@/components/pages/Washrooms/Washrooms.vue';
import Reviews from '@/components/pages/Reviews/Reviews.vue';
import ReviewsDetail from '@/components/pages/ReviewsDetail/ReviewsDetail.vue';
import Account from '@/components/pages/Account/Account.vue';
import Admin from '@/components/pages/Admin/Admin.vue';
import ResetPassword from '@/components/pages/ResetPassword/ResetPassword.vue';


Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/retailers',
      name: 'Retailers',
      component: Retailers
    },
    {
      path: '/retailers/:id',
      name: 'Retailers Detail',
      component: RetailersDetail
    },
    {
      path: '/retailers/multisite/:multisiteId',
      name: 'RetailersForMultisite',
      component: Retailers
    },
    {
      path: '/retailers-multi',
      name: 'Retailers Multi',
      component: RetailersMulti
    },
    {
      path: '/service-providers',
      name: 'ServiceProviders',
      component: ServiceProviders
    },
    {
      path: '/service-providers/:id',
      name: 'ServiceProviderDetail',
      component: ServiceProviderDetail
    },
    {
      path: '/service-relationships',
      name: 'ServiceRelationships',
      component: ServiceRelationships
    },
    {
      path: '/service-relationships/:id',
      name: 'ServiceRelationshipsWithId',
      component: ServiceRelationships
    },
    {
      path: '/washrooms',
      name: 'Washrooms',
      component: Washrooms
    },
    {
      path: '/washrooms/retailer/:retailerId',
      name: 'WashroomsForRetailer',
      component: Washrooms
    },
    {
      path: '/washrooms/multisite/:multisiteId',
      name: 'WashroomsForMultisite',
      component: Washrooms
    },
    {
      path: '/reviews',
      name: 'Reviews',
      component: Reviews
    },
    {
      path: '/reviews/:id',
      name: 'ReviewsDetail',
      component: ReviewsDetail
    },
    {
      path: '/reviews/retailer/:retailerId',
      name: 'ReviewsForRetailer',
      component: Reviews
    },
    {
      path: '/reviews/washroom/:washroomId',
      name: 'ReviewsForWashroom',
      component: Reviews
    },
    {
      path: '/reviews/multisite/:multisiteId',
      name: 'ReviewsForMultisite',
      component: Reviews
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin
    },
    {
      path: '/reset-password/:token',
      name: 'ResetPassword',
      component: ResetPassword
    }
  ]
})

router.beforeEach((to, from, next) => {
  let publicPageNames = ['Login', 'ActivateAccount', 'ResetPassword'];

  // Check if page is not allowed public access
  if (publicPageNames.indexOf(to.name) == -1) {
    if (!window.initialRouteChecked) {
      if (localStorage.getItem('accessToken')) {

        AuthenticationService.checkToken(localStorage.getItem('accessToken')).then((result) => {
          if (result == false) {
            router.push('/?referrerurl=' + encodeURIComponent(to.fullPath));
          }

          window.initialRouteChecked = true;
          next();
        });
      }
      else {
        router.push('/?referrerurl=' + encodeURIComponent(to.fullPath));

        window.initialRouteChecked = true;

        next();
      }
    }
    else {
      next();
    }
  }
  else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js